import axios from "axios";

export default {
    login,
    logout,
    changePassword,
    resetPassword,
    requestPasswordReset,
    currentUser,
    acceptInvitation,
    checkUserAuthMethod,
    initiateSsoLogin,
    linkExistingSso,
    linkExistingSsoWithToken,
    getUserOnboardState,
    provisionSso,
    validateSsoOnboardToken,
    onboardWithToken,
    logoutOfSso,
    changeSsoPassword,
    getSsoOptions
};

export async function login(emailAddress, password) {
    return await axios.post("/api/Account/Login", { emailAddress, password });
}

export async function logout(localOnly = true) {
    await axios.post("/api/Account/Logout", null, { params: { localOnly } });
}

// Full browser navigation (not an axios call) - the server signs out locally then redirects to
// Authentik's end-session endpoint, which redirects back to the login page.
export function logoutOfSso() {
    window.location.assign("/api/Account/Logout?localOnly=false");
}

// Full browser navigation - the server redirects to Shaping Minds ID's change password page.
export function changeSsoPassword() {
    window.location.assign("/api/Account/ChangeSsoPassword");
}

export async function getSsoOptions() {
    const response = await axios.get("/api/Account/SsoOptions");
    return response.data;
}

export async function checkUserAuthMethod(emailAddress) {
    const response = await axios.post("/api/Account/CheckUserAuthMethod", { emailAddress });
    return response.data;
}

// Full browser navigation (not an axios call) - the server redirects to Authentik.
export function initiateSsoLogin(emailAddress, returnUrl) {
    const params = new URLSearchParams();
    if (emailAddress) {
        params.set("email", emailAddress);
    }
    if (returnUrl) {
        params.set("returnUrl", returnUrl);
    }

    const query = params.toString();
    window.location.assign(`/api/Account/ExternalLogin${query ? `?${query}` : ""}`);
}

// Full browser navigations - the server sends the user to sign in to their existing Shaping
// Minds ID, and links the one they sign in to.
export function linkExistingSso() {
    window.location.assign("/api/SSOOnboard/LinkExisting");
}

export function linkExistingSsoWithToken(token, personName) {
    const params = new URLSearchParams({ token });
    if (personName) {
        params.set("personName", personName);
    }

    window.location.assign(`/api/SSOOnboard/LinkExistingWithToken?${params}`);
}

export async function getUserOnboardState() {
    const response = await axios.get("/api/SSOOnboard/GetUserOnboardState");
    return response.data;
}

export async function provisionSso(linkExisting, password) {
    const response = await axios.post("/api/SSOOnboard/ProvisionSso", { linkExisting, password });
    return response.data;
}

export async function validateSsoOnboardToken(token) {
    const response = await axios.post("/api/SSOOnboard/ValidateSsoOnboardToken", { token });
    return response.data;
}

export async function onboardWithToken(token, linkExisting, password, personName) {
    await axios.post("/api/SSOOnboard/OnboardWithToken", {
        token,
        linkExisting,
        password,
        personName
    });
}

export async function changePassword(oldPassword, newPassword) {
    await axios.post("api/Account/ChangePassword", { oldPassword, newPassword });
}

export async function resetPassword(token, newPassword) {
    await axios.post("api/Account/ResetPassword", { token, newPassword });
}

export async function requestPasswordReset(emailAddress) {
    await axios.post("api/Account/RequestPasswordReset", { emailAddress });
}

export async function currentUser() {
    const response = await axios.get("/api/Account/CurrentUser");
    const user = response.data;
    return !user ? null : user;
}

export async function acceptInvitation(token, newPassword, personName) {
    await axios.post("api/Account/AcceptInvitation", { token, newPassword, personName });
}
